import { Text } from '@mantine/core';

export const TextConfig = Text.extend({
  defaultProps: {
    size: 'sm',
  },
});
